import * as constants from '../constants/trainees'
import Api from '../services/api.js'

export function getTraineesRequest(){
  return {
    type: constants.GET_TRAINEES_REQUEST,
  }
}

export function getTraineesSuccess(body){
  return {
    type: constants.GET_TRAINEES_SUCCESS,
    body: body
  }
}

export function getTraineesFailure(exception){
  return {
    type: constants.GET_TRAINEES_FAILURE,
    exception: exception
  }
}

export function getTrainees(params) {
  return dispatch => {
    dispatch(getTraineesRequest())
    const api = new Api();
    return api.makeRequest({
      method: "get",
      url: "/api/v1/trainees",
      params: params
    })
    .then(response => {
      dispatch(getTraineesSuccess(response.data))
    })
    .catch(err => dispatch(getTraineesFailure(err)))
  }
}

export function exportToExcel(options) {
  const api = new Api();
  return api.get("/api/v1/trainees/generate_sheets", { params: options, responseType: 'blob' })
}

export function renameTag(options) {
  const api = new Api();
  return api.put("/api/v1/tag", options)
}

export function addTraineeRequest(){
  return {
    type: constants.ADD_TRAINEE_REQUEST,
  }
}

export function addTraineeSuccess(body){
  return {
    type: constants.ADD_TRAINEE_SUCCESS,
    body: body
  }
}

export function addTraineeFailure(exception){
  return {
    type: constants.ADD_TRAINEE_FAILURE,
    exception: exception
  }
}

export function showDuplicateTraineeWarning(trainee, duplicates, duplicateTraineeMethod){
  return {
    type: constants.SHOW_DUPLICATE_TRAINEE_WARNING,
    trainee: trainee,
    duplicates: duplicates,
    duplicateTraineeMethod: duplicateTraineeMethod
  }
}

export function addTraineeWithValidation(params) {
  return dispatch => {
    dispatch(addTraineeRequest())
    const api = new Api();
    return api.post("/api/v1/trainee/validation", params)
    .then(response => {
      if (Array.isArray(response.data)) {
        dispatch(showDuplicateTraineeWarning(params, response.data, 'add'))
      }
      else {
        dispatch(addTraineeSuccess(response.data))
      }
    })
    .catch(err => dispatch(addTraineeFailure(err)));
  }
}

export function addTrainee(params) {
  return dispatch => {
    dispatch(addTraineeRequest())
    const api = new Api();
    return api.post("/api/v1/trainee", params)
    .then(response => {
      dispatch(addTraineeSuccess(response.data))
    })
    .catch(err => dispatch(addTraineeFailure(err)));
  }
}

export function addDuplicateTraineeRequest(){
  return {
    type: constants.ADD_DUPLICATE_TRAINEE_REQUEST,
  }
}

export function addDuplicateTraineeSuccess(body){
  return {
    type: constants.ADD_DUPLICATE_TRAINEE_SUCCESS,
    body: body
  }
}

export function addDuplicateTraineeFailure(exception){
  return {
    type: constants.ADD_DUPLICATE_TRAINEE_FAILURE,
    exception: exception
  }
}

export function addDuplicateTrainee(params) {
  return dispatch => {
    dispatch(addDuplicateTraineeRequest())
    const api = new Api();
    return api.post("/api/v1/trainee", params)
    .then(response => {
      dispatch(addDuplicateTraineeSuccess(response.data))
    })
    .catch(err => dispatch(addDuplicateTraineeFailure(err)));
  }
}

export function updateTraineeRequest(){
  return {
    type: constants.UPDATE_TRAINEE_REQUEST,
  }
}

export function updateTraineeSuccess(body){
  return {
    type: constants.UPDATE_TRAINEE_SUCCESS,
    body: body
  }
}

export function updateTraineeFailure(exception){
  return {
    type: constants.UPDATE_TRAINEE_FAILURE,
    exception: exception
  }
}

export function updateTrainee(params) {
  return dispatch => {
    dispatch(updateTraineeRequest())
    const api = new Api();
    return api.put("/api/v1/trainee/"+params.id, params)
    .then(response => {
      dispatch(updateTraineeSuccess(response.data))
    })
    .catch(err => dispatch(updateTraineeFailure(err)));
  }
}

export function updateTraineeWithValidation(params) {
  return dispatch => {
    dispatch(updateTraineeRequest())
    const api = new Api();
    return api.put("/api/v1/trainee/"+params.id+"/validation", params)
    .then(response => {
      if (Array.isArray(response.data)) {
        dispatch(showDuplicateTraineeWarning(params, response.data, 'update'))
      }
      else {
        dispatch(updateTraineeSuccess(response.data))
      }
    })
    .catch(err => dispatch(updateTraineeFailure(err)));
  }
}

export function updateDuplicateTraineeRequest(){
  return {
    type: constants.UPDATE_DUPLICATE_TRAINEE_REQUEST,
  }
}

export function updateDuplicateTraineeSuccess(body){
  return {
    type: constants.UPDATE_DUPLICATE_TRAINEE_SUCCESS,
    body: body
  }
}

export function updateDuplicateTraineeFailure(exception){
  return {
    type: constants.UPDATE_DUPLICATE_TRAINEE_FAILURE,
    exception: exception
  }
}

export function updateDuplicateTrainee(params) {
  return dispatch => {
    dispatch(updateDuplicateTraineeRequest())
    const api = new Api();
    return api.put("/api/v1/trainee/"+params.id, params)
    .then(response => {
      dispatch(updateDuplicateTraineeSuccess(response.data))
    })
    .catch(err => dispatch(updateDuplicateTraineeFailure(err)));
  }
}

export function archiveTraineeRequest(){
  return {
    type: constants.ARCHIVE_TRAINEE_REQUEST,
  }
}

export function archiveTraineeSuccess(body){
  return {
    type: constants.ARCHIVE_TRAINEE_SUCCESS,
    body: body
  }
}

export function archiveTraineeFailure(exception){
  return {
    type: constants.ARCHIVE_TRAINEE_FAILURE,
    exception: exception
  }
}

export function archiveTrainee(trainee_id) {
  return dispatch => {
    dispatch(archiveTraineeRequest())
    const api = new Api();
    return api.put(`/api/v1/trainee/${trainee_id}/archive_trainee`, {})
    .then(response => {
      dispatch(archiveTraineeSuccess(response.data))
    })
    .catch(err => dispatch(archiveTraineeFailure(err)));
  }
}

export function unarchiveTraineeRequest(){
  return {
    type: constants.UNARCHIVE_TRAINEE_REQUEST,
  }
}

export function unarchiveTraineeSuccess(body){
  return {
    type: constants.UNARCHIVE_TRAINEE_SUCCESS,
    body: body
  }
}

export function unarchiveTraineeFailure(exception){
  return {
    type: constants.UNARCHIVE_TRAINEE_FAILURE,
    exception: exception
  }
}

export function unarchiveTrainee(trainee_id) {
  return dispatch => {
    dispatch(unarchiveTraineeRequest())
    const api = new Api();
    return api.put(`/api/v1/trainee/${trainee_id}/unarchive_trainee`, {})
    .then(response => {
      dispatch(unarchiveTraineeSuccess(response.data))
    })
    .catch(err => dispatch(unarchiveTraineeFailure(err)));
  }
}



// WEBPACK FOOTER //
// ./src/actions/trainees.js